/**
 * Query key factory for auth-related queries
 * Creates structured and predictable query keys for React Query
 */
export const authKeys = {
  // Base key for all auth-related queries
  all: ['auth'] as const,
  
  // User information
  user: () => [...authKeys.all, 'user'] as const,
  
  // Admin status
  adminStatus: () => [...authKeys.all, 'admin-status'] as const,
  
  // Session information
  session: () => [...authKeys.all, 'session'] as const,
};